import DevIllustration from './devillustration'

export default {
  DevIllustration
}
